import { getCurrencySymbol, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatPrefix, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { RootState } from '@next/core-lib/app';
import { AgrNumberDirective } from '@next/core-lib/form';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { skipWhile, take } from 'rxjs/operators';

import { Discount } from '../../models/settings.model';
import * as settingActions from '../../store/actions/settings.actions';
import { getDiscount } from '../../store/selectors/settings.selectors';

@Component({
  selector: 'app-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatPrefix,
    MatLabel,
    MatInput,
    AgrNumberDirective,
    NgIf,
    MatError,
    MatButton,
    TranslatePipe,
  ],
})
export class DiscountComponent {
  form = new FormGroup({
    bulk: new FormControl(null, []),
    purchase: new FormControl(null, []),
    deliveryday: new FormControl(null, []),
    payment: new FormControl(null, [Validators.min(0), Validators.max(100)]),
    memberBenefit: new FormControl(null, [Validators.min(0), Validators.max(100)]),
    memberDiscount: new FormControl(null, []),
  });
  currency: string;

  constructor(
    private readonly store: Store<RootState>,
    private readonly locale: LocaleService,
  ) {
    this.store
      .select(getDiscount)
      .pipe(
        skipWhile((discount) => discount === null),
        take(1),
      )
      .subscribe((discount) => {
        if (discount) {
          this.form.controls.bulk.setValue(discount.bulkDiscountPer100Kg);
          this.form.controls.purchase.setValue(discount.purchaseDiscountPer100Kg);
          this.form.controls.deliveryday.setValue(discount.deliveryDayDiscountPer100Kg);
          this.form.controls.payment.setValue(discount.paymentDiscountPercentage);
          this.form.controls.memberBenefit.setValue(discount.memberBenefitDiscountPercentage);
          this.form.controls.memberDiscount.setValue(discount.memberDiscountPer100Kg);
          this.currency = discount.currency
            ? discount.currency
            : getCurrencySymbol(this.locale.getCurrency(), 'narrow');
        }
      });
  }

  save() {
    const discount = <Discount>{
      bulkDiscountPer100Kg: this.form.controls.bulk.value,
      purchaseDiscountPer100Kg: this.form.controls.purchase.value,
      deliveryDayDiscountPer100Kg: this.form.controls.deliveryday.value,
      paymentDiscountPercentage: this.form.controls.payment.value,
      memberBenefitDiscountPercentage: this.form.controls.memberBenefit.value,
      memberDiscountPer100Kg: this.form.controls.memberDiscount.value,
      currency: this.currency,
    };
    this.store.dispatch(settingActions.upsertDiscountRequest({ discount }));
  }
}
